import React, { useMemo, useState } from 'react';
import { Input } from './ui/input';
import { X, Plus, UserRound } from 'lucide-react';
import { splitAuthors } from './CatalogFacets';

const fold = (t) => (t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

// Authors are stored as "A; B" so search and author links keep working
export const AuthorsInput = ({ value, onChange, known }) => {
  const authors = splitAuthors(value);
  const [draft, setDraft] = useState('');
  const [open, setOpen] = useState(false);
  const options = useMemo(() => {
    const q = fold(draft);
    if (!q) return [];
    return known.filter((a) => fold(a).includes(q) && !authors.some((x) => fold(x) === fold(a))).slice(0, 8);
  }, [draft, known, authors]);

  const add = (name) => {
    const n = (known.find((a) => fold(a) === fold(name)) || name).trim();
    if (!n || authors.some((x) => fold(x) === fold(n))) { setDraft(''); return; }
    onChange([...authors, n].join('; '));
    setDraft('');
    setOpen(false);
  };
  const remove = (i) => onChange(authors.filter((_, j) => j !== i).join('; '));

  return (
    <div data-testid="authors-input">
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 6, minHeight: 26, alignItems: 'center' }}>
          {!authors.length && <span style={{ fontSize: '0.78rem', color: '#a0aec0' }}>Nenhum autor incluído</span>}
          {authors.map((a, i) => (
            <span key={a + i} data-testid={`author-chip-${i}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#edf7f7', color: '#2D3748', border: '1px solid #b2dcdc', borderRadius: 50, padding: '0.15rem 0.35rem 0.15rem 0.65rem', fontSize: '0.82rem' }}>
              {a}
              <button type="button" onClick={() => remove(i)} aria-label={`Remover ${a}`} data-testid={`author-chip-remove-${i}`}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#718096', display: 'inline-flex', padding: 0 }}><X className="w-3 h-3" /></button>
            </span>
          ))}
      </div>
      <div style={{ position: 'relative', display: 'flex', gap: 6 }}>
        <Input value={draft} placeholder={authors.length ? 'Adicionar outro autor' : 'Nome do autor'} data-testid="author-draft-input"
          onChange={(e) => { setDraft(e.target.value); setOpen(true); }}
          onBlur={() => { setOpen(false); if (draft.trim()) add(draft); }}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); add(options[0] && fold(options[0]).startsWith(fold(draft)) ? options[0] : draft); } }} />
        <button type="button" onClick={() => add(draft)} disabled={!draft.trim()} data-testid="author-add-btn" title="Incluir autor"
          style={{ border: '1px solid #e2e8f0', borderRadius: 6, background: 'white', padding: '0 0.6rem', cursor: draft.trim() ? 'pointer' : 'default', color: '#2c7a7b' }}>
          <Plus className="w-4 h-4" />
        </button>
        {open && options.length > 0 && (
          <div style={{ position: 'absolute', top: '100%', left: 0, right: 40, zIndex: 20, background: 'white', border: '1px solid #e2e8f0', borderRadius: 8, marginTop: 4, boxShadow: '0 8px 20px rgba(0,0,0,0.08)' }}>
            {options.map((o) => (
              <button key={o} type="button" onMouseDown={(e) => { e.preventDefault(); add(o); }} data-testid={`author-option-${o}`}
                style={{ display: 'flex', alignItems: 'center', gap: 6, width: '100%', textAlign: 'left', padding: '0.45rem 0.75rem', background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.88rem' }}>
                <UserRound className="w-3 h-3" style={{ color: '#a0aec0' }} />{o}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
